<template>
  <v-layout v-resize="onResize" column style="padding-top: 0px">
    <div class="container-fluid">
      <div class="row" style="margin-top: 0px">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">Master Data</div>
            <div class="card-body">
              <!-- persistent -->
              <v-dialog v-model="dialogLoading" width="150px" height="auto">
                <v-card width="150px" height="150px" style="text-align: center">
                  <v-progress-circular
                    :size="70"
                    :width="7"
                    color="orange"
                    indeterminate
                    style="margin-top: 40px"
                  ></v-progress-circular>
                </v-card>
              </v-dialog>

              <v-data-table
                :headers="headers"
                :items="master_data"
                :hide-default-header="isMobile"
                :class="{mobile: isMobile}"
                :search="search"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    
                    <v-btn color="#FCC133" dark @click="newData">
                      New Data Master
                    </v-btn>

                    <v-dialog v-model="dialog" persistent max-width="400px">
                      <template v-slot:activator="{ on, attrs }">
                        <div class="row">
                          <div class="col-md-7"></div>
                          <div class="col">
                            <!-- <v-btn v-if="role=='1'" color="#FCC133" dark >Validasi Huang Yi</v-btn> -->
                          </div>
                        </div>
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="text-h5">Data Master</span>
                        </v-card-title>
                        <v-card-text>
                          <div class="row">
                            <div class="col" style="width: 500px">
                              <v-select
                                v-model="tipe_data"
                                :items="listTipeData"
                                item-text="TIPE_DATA"
                                item-value="TIPE_DATA"
                                label="Data Type"
                                required
                                @change="checkIfNegara"
                              ></v-select>
                            </div>
                            <div class="col">
                              <v-select
                                v-model="negara"
                                :items="listNegara"
                                item-text="DESKRIPSI_DATA"
                                item-value="ID_DATA"
                                label="Parent Data"
                                required
                                :disabled="IfChooseKota"
                              ></v-select>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col" style="width: 500px">
                              <v-text-field
                                label="Description"
                                v-model="description"
                                required
                              ></v-text-field>
                            </div>
                            <div class="col">
                              <v-text-field
                                label="Number Code"
                                v-model="number_code"
                                required
                                :disabled="IfNumberCode"
                                @change="checkNumberValid"
                              ></v-text-field>
                            </div>
                          </div>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="#FCC133 darken-1"
                            text
                            @click="dialog = false"
                          >
                            Close
                          </v-btn>
                          <v-btn color="#FCC133 darken-1" text @click="save()">
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-divider class="mx-4" vertical></v-divider>
                     <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Search Master Data"
                          single-line
                          hide-details
                          color="#F9A825"
                        ></v-text-field>
                  </v-toolbar>
                </template>
                <template v-slot:item.TIPE_DATA="{ item }">
                  <span>{{ item.TIPE_DATA.replace('_',' ') }}</span>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-pencil
                  </v-icon>
                 
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import axios from '@/axios'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
export default {
    data: () => ({
        dialog: false,
        dialogLoading: false,
        headers: [
        { text: 'Data Type', value: 'TIPE_DATA', filterable: true },
        { text: 'Description',value: 'DESKRIPSI_DATA', filterable: true},
        { text: 'Number Code', value: 'KODE_NUMBER' , filterable: true},
        // { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false },
        ],
        tipe_data:[],
        isMobile: false,
        editedIndex: -1,
        listNegara:[],
        listTipeData:[],
        tipe_data:'',
        id_data:'',
        negara:'',
        description:'',
        search: '',
        number_code:'',
        master_data:[],
        flagEdited:false,
        IfChooseKota:true,
        IfNumberCode:true,
    }),
    computed: {
    },
    watch: {
        dialog (val) {
            val || this.close()
        },
    },
    created () {
        this.initialize()
    },
    beforeCreate: function () {
        if (!this.$session.exists()) {
        this.$router.push('/')
        }
    },
    methods: {
        onResize() {
          if (window.innerWidth < 769)
            this.isMobile = true;
          else
            this.isMobile = false;
        },
        initialize () {
            // console.log('Dash '+this.$session.get('token'));
            this.master_data=[];
            axios({
                method: 'get',
                url: 'get_list_master_data',
                headers: {
                  Authorization: 'Bearer ' + this.$session.get('token'),
                },
            }).then(response => {
                if(response.data){
                    this.master_data=response.data;
                }
            }).catch(error=>{
                console.log('Error Fetch Data '+error);
            });

            this.flagEdited=false;
            axios({
                method: 'get',
                url: 'get_list_tipe_data',
                headers: {
                  Authorization: 'Bearer ' + this.$session.get('token'),
                },
            }).then(response => {
                if(response.data){
                    this.listTipeData=response.data;
                    axios({
                        method: 'get',
                        url: 'get_list_daftar_negara',
                        headers: {
                          Authorization: 'Bearer ' + this.$session.get('token'),
                        },
                    }).then(response => {
                        if(response.data){
                            this.listNegara=response.data;
                        }
                    }).catch(error=>{
                        console.log('Error Fetch Data '+error);
                    });
                }
            }).catch(error=>{
                console.log('Error Fetch Data '+error);
            });
        },
        editItem (item) {//open modal
            this.flagEdited=true;
            this.id_data=''
            this.id_data=item.ID_DATA
            this.tipe_data=item.TIPE_DATA;
            this.checkIfNegara();
            // this.negara=item.TIPE_DATA;
         //   console.log(item);
            if(item.PARENT_DATA){
                // console.log(this.listNegara);
                this.negara = this.listNegara.find(item_d => item_d.ID_DATA === parseInt(item.PARENT_DATA));
                this.negara = this.negara.ID_DATA;
            }

            this.description=item.DESKRIPSI_DATA;
            this.number_code=item.KODE_NUMBER;

            this.dialog = true
        },
        deleteItem (item) {
            confirm('Are you sure you want to delete this item?') &&
            axios({
                    method:'post',
                    url:'delete_master_data',
                    data:{
                        id: item.ID_DATA
                    },
                    headers: {
                        'Authorization': 'Bearer '+this.$session.get('token')
                    }
                }).then(response => {
                    if(response){
                        this.initialize();
                         Swal.fire({
                                title:'Peringatan',
                                icon :'success',
                                text:response.data
                        });
                    }
                    // console.log(response);
                }).catch(error => {
                    Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:error.response
                        });
                    // console.log(error.response);
                });
        },
        close () {
            this.dialog = false
        },
        save () {
             if (this.flagEdited) {
                if(this.id_data!=='' && this.id_data!==null)
                {
                    if( (this.number_code===null || this.number_code.length<4) && this.tipe_data==='Kota_Daftar')
                    {

                        Swal.fire({
                                title:'Peringatan',
                                icon :'info',
                                text:'Number Code wajib 4 digit'
                        });
                    }else{
                        axios({
                            method:'post',
                            url:'update_master_data',
                            data:{
                                id: this.id_data,
                                tipe_data: this.tipe_data,
                                parent_data: this.negara,
                                kode_number: this.number_code,
                                deskripsi_data: this.description
                            },
                            headers: {
                                'Authorization': 'Bearer '+this.$session.get('token')
                            }
                        }).then(response => {
                            if(response.status=='200'){
                                this.initialize();

                                Swal.fire({
                                        title:'Peringatan',
                                        icon :'success',
                                        text:response.data
                                });
                            }
                            // console.log(response);
                        }).catch(error => {

                                Swal.fire({
                                        title:'Peringatan',
                                        icon :'error',
                                        text:'Failed'
                                });
                                // console.log(error.response);
                        });
                    }

                }


            // Object.assign(this.desserts[this.editedIndex], this.editedItem)
            } else {
                axios({
                    method:'post',
                    url:'master_data',
                    data:{
                        tipe_data: this.tipe_data,
                        parent_data: this.negara,
                        kode_number: this.number_code,
                        deskripsi_data: this.description
                    },
                    headers: {
                        'Authorization': 'Bearer '+this.$session.get('token')
                    }
                }).then(response => {
                    if(response.status=='200'){
                        this.initialize();

                        Swal.fire({
                            title:'Peringatan',
                            icon :'success',
                            text:response.data
                        });
                    }
                    // console.log(response);
                }).catch(error => {
                        Swal.fire({
                            title:'Peringatan',
                            icon :'error',
                            text:'Failed'
                        });
                    // console.log(error.response);
                });
            }
            this.flagEdited=false;
            this.close()
        },
        newData(){
            this.reset();
            this.flagEdited=false;
            this.dialog=true;
        },
        checkIfNegara(){
            // alert(this.tipe_data+' '+this.IfChooseKota)
            this.number_code='';
            this.description='';

            if(this.tipe_data=='Kota_Daftar'){
                this.IfChooseKota=false;
            }
            else {
                this.IfChooseKota=true;//Keep Disabled
            }

            if(this.tipe_data=='Kota_Daftar' || this.tipe_data=='Negara'){
                this.IfNumberCode=false;
            }else{
                this.IfNumberCode=true;
            }
        },
        checkNumberValid(){
            // if(this.tipe_data=='Negara'){
            //     if(this.number_code.length=='3')
            // }else if(this.tipe_data=='Kota_Daftar'){
            //     let isnum = /^\d+$/.test(this.number_code);
            //     if(this.number_code.length=='3' && isnum){

            //     }else{

            //     }

            // }
        },
        reset(){
            this.tipe_data='';
            this.negara='';
            this.description='';
            this.number_code='';

        },
        onCloseDialog(){
            // console.log('Close kah ?');
            this.dialog = false;
        }
    },
    components: {
    },
}
</script>

<style type="text/css">
.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}
</style>
